const doc = [({"en":({"js":({"admin":({"activities":({"create_card":({"surveys_card":({"add_survey":"Add survey"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;